function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import rgba from 'polished/lib/color/rgba';
import typography from '../utils/typography';
var useStyles = _ref => {
  var {
    theme
  } = _ref;
  var isHc = theme.mode === 'contrast';
  return {
    root: {
      boxSizing: 'content-box',
      display: 'flex',
      flexFlow: 'row wrap',
      height: "calc(2 * ".concat(theme.orbitalSix, ")"),
      paddingBottom: theme.orbitalFour
    },
    itemsSelected: _objectSpread(_objectSpread({
      backgroundColor: theme.palette.primary.background,
      borderRadius: theme.borderRadius,
      boxSizing: 'border-box',
      color: theme.palette.primary.default,
      display: 'inline-block'
    }, typography(theme).label), {}, {
      lineHeight: theme.typography.lineHeight3,
      marginLeft: theme.layout.size3,
      padding: "calc(".concat(theme.orbitalThree, " - 1px)")
    }, isHc && {
      color: theme.palette.foreground.default
    }),
    actionArea: {
      display: 'flex',
      flexFlow: 'row wrap',
      flexGrow: 1,
      marginRight: theme.layout.size3
    },
    controlArea: {
      marginLeft: theme.layout.size2
    }
  };
};
export var useColumnOptionsStyles = _ref2 => {
  var {
    theme
  } = _ref2;
  return React.useMemo(() => {
    var isHc = theme.mode === 'contrast';
    return {
      button: {
        marginLeft: theme.layout.size3
      },
      list: _objectSpread({
        border: "1px solid ".concat(theme.palette.stroke.default),
        borderRadius: '12px',
        flex: '1 0',
        marginRight: '-1px',
        maxHeight: '288px',
        overflowX: 'hidden',
        overflowY: 'auto'
      }, isHc && {
        border: "2px solid ".concat(theme.palette.primary.default)
      }),
      moveButtons: {
        flex: '0 1',
        marginLeft: '8px'
      },
      panel: {
        display: 'flex'
      },
      reset: {
        marginTop: '12px'
      },
      saveButton: {
        marginRight: '12px'
      }
    };
  }, [theme]);
};
export var useListItemStyles = _ref3 => {
  var {
    firstItem,
    selected,
    theme
  } = _ref3;
  return React.useMemo(() => {
    var isHc = theme.mode === 'contrast';
    var getOptionColors = _ref4 => {
      var {
        main,
        hover,
        active
      } = _ref4;
      return _objectSpread({
        backgroundColor: selected ? main : undefined,
        ':hover': {
          backgroundColor: "".concat(hover, "!important")
        },
        ':focus': {
          backgroundColor: main
        },
        ':active': {
          backgroundColor: "".concat(active, "!important")
        }
      }, isHc && {
        backgroundColor: selected ? rgba(main, 0.1) : undefined,
        borderTop: !firstItem ? "2px solid ".concat(main) : undefined,
        '& + div': {
          borderTopColor: main
        },
        ':hover': {
          backgroundColor: "".concat(rgba(hover, 0.1), "!important"),
          borderTop: !firstItem ? "2px solid ".concat(hover, "!important") : undefined,
          '& + div': {
            borderTopColor: "".concat(hover, "!important")
          }
        },
        ':focus': {
          backgroundColor: rgba(main, 0.1),
          borderTop: !firstItem ? "2px solid ".concat(main) : undefined
        },
        ':active': {
          backgroundColor: "".concat(rgba(active, 0.1), "!important"),
          borderTop: !firstItem ? "2px solid ".concat(active, "!important") : undefined,
          '& + div': {
            borderTopColor: "".concat(active, "!important")
          }
        }
      });
    };
    return _objectSpread(_objectSpread({
      borderBottom: '0 !important',
      display: 'flex',
      padding: theme.orbitalThree
    }, getOptionColors({
      main: theme.palette.primary.background,
      hover: theme.palette.neutral.backgroundLight,
      active: theme.palette.neutral.background
    })), isHc && _objectSpread({}, getOptionColors({
      main: theme.palette.primary.default,
      hover: theme.palette.primary.hover,
      active: theme.palette.primary.active
    })));
  }, [firstItem, selected, theme]);
};
export default useStyles;